var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "jsStationAlerts" }, [
    _c(
      "div",
      {
        staticClass: "main-form ic-form header-form itinerary-form dark-form",
        class: _vm.mainFormContainer,
      },
      [
        _c(
          "form",
          {
            attrs: {
              role: "form",
              name: "searchTrain",
              method: "post",
              action: _vm.action,
              autocomplete: "off",
              id: "searchTrainForm",
            },
          },
          [
            _vm._t("extra"),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "justify-content-between d-flex gy-4 flex-column",
                class: _vm.localization === "sidebar" ? "" : "flex-lg-row",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex-grow-1 d-flex py-2 align-items-end",
                    class:
                      _vm.localization === "sidebar" ? "p-0 py-lg-2" : "p-lg-2",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "typehead-container w-100" },
                      [
                        _vm._t("destination-from", function () {
                          return [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "stname-0" },
                              },
                              [_vm._v("Jadę z")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "start no-border",
                                attrs: {
                                  role: "combobox",
                                  "aria-haspopup": "listbox",
                                  "aria-expanded": "false",
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    staticClass:
                                      "jsStationTypeaheadItem jsNearestStationItem form-control",
                                    attrs: {
                                      type: "search",
                                      id: "stname-0",
                                      name: "stname[0]",
                                      placeholder: "np. Warszawa Centralna",
                                      autocomplete: "off",
                                      role: "searchbox",
                                      "aria-multiline": "false",
                                      "aria-autocomplete": "list",
                                    },
                                    domProps: { value: _vm.stname0 },
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    staticClass: "jsTypeaheadItem-Value",
                                    attrs: {
                                      type: "hidden",
                                      name: "stid[0]",
                                      id: "stid-0",
                                    },
                                    domProps: { value: _vm.stid0 },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-none",
                    class: _vm.localization === "sidebar" ? "" : "d-lg-block",
                    staticStyle: { width: "32px" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "switch d-flex h-100 align-items-center focus",
                        attrs: { tabindex: "0" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.reverse.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "32",
                              height: "32",
                              viewBox: "0 0 32 32",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M25.2379 7.93561L21.4398 4.06365C20.929 3.54295 20.0929 3.5349 19.5722 4.04567L19.5273 4.09109C19.0186 4.60963 19.0186 5.43993 19.5273 5.95847L21.1772 7.64095L4.04927 7.63962C3.31289 7.63962 2.71594 8.23658 2.71594 8.97296L2.71594 9.02478C2.71594 9.76116 3.31289 10.3581 4.04927 10.3581L21.0759 10.3583L19.5273 11.9356C19.0186 12.4542 19.0186 13.2845 19.5273 13.803L19.5542 13.8304C20.065 14.3511 20.9011 14.3592 21.4218 13.8484L21.4398 13.8304L25.2379 9.95847C25.4727 9.71914 25.5991 9.41341 25.6172 9.10256L25.6172 8.79152C25.5991 8.48068 25.4727 8.17494 25.2379 7.93561Z",
                                fill: "#FA6A2E",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M2.76205 24.0643L6.5602 27.9362C7.07098 28.4569 7.90715 28.465 8.42785 27.9542L8.47274 27.9088C8.9814 27.3903 8.9814 26.56 8.47274 26.0414L6.82281 24.3589L22.9507 24.3603C23.6871 24.3603 24.2841 23.7633 24.2841 23.0269L24.2841 22.9751C24.2841 22.2387 23.6871 21.6418 22.9507 21.6418L6.92415 21.6416L8.47274 20.0643C8.9814 19.5457 8.9814 18.7154 8.47274 18.1969L8.44582 18.1695C7.93505 17.6488 7.09887 17.6407 6.57818 18.1515L6.5602 18.1695L2.76205 22.0414C2.52728 22.2808 2.40087 22.5865 2.38281 22.8973L2.38281 23.2084C2.40087 23.5192 2.52728 23.825 2.76205 24.0643Z",
                                fill: "#FA6A2E",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Zamień stację odjazdu ze stacją przyjazdu."),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex-grow-1 d-flex py-2 align-items-end",
                    class:
                      _vm.localization === "sidebar" ? "p-0 py-lg-2" : "p-lg-2",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "typehead-container w-100" },
                      [
                        _vm._t("destination-to", function () {
                          return [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "stname-1" },
                              },
                              [_vm._v("Jadę do")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "end no-border",
                                attrs: {
                                  role: "combobox",
                                  "aria-haspopup": "listbox",
                                  "aria-expanded": "false",
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    staticClass:
                                      "jsStationTypeaheadItem jsNearestStationItem form-control",
                                    attrs: {
                                      type: "search",
                                      id: "stname-1",
                                      name: "stname[1]",
                                      placeholder: "np. Szczecin Gł.",
                                      autocomplete: "off",
                                      role: "searchbox",
                                      "aria-multiline": "false",
                                      "aria-autocomplete": "list",
                                    },
                                    domProps: { value: _vm.stname1 },
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    staticClass: "jsTypeaheadItem-Value",
                                    attrs: {
                                      type: "hidden",
                                      name: "stid[1]",
                                      id: "stid-1",
                                    },
                                    domProps: { value: _vm.stid1 },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex py-2 align-items-end",
                    class:
                      _vm.localization === "sidebar"
                        ? "p-0 py-lg-2 col-lg-12"
                        : "col-lg-4 p-lg-2",
                  },
                  [
                    _vm._t("date-time-pickers", function () {
                      return [_c("date-time")]
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex py-2 align-items-end",
                    class:
                      _vm.localization === "sidebar" ? "p-0 py-lg-2" : "p-lg-2",
                    staticStyle: { "min-width": "130px" },
                  },
                  [
                    _c("input", {
                      staticClass: "jsVariable-HafasPage",
                      attrs: {
                        type: "hidden",
                        name: "hafasPage",
                        value: "{$hafas_page}",
                      },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "jsVariable-HafasSort",
                      attrs: { type: "hidden", name: "hafasSort", value: "" },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "jsVariable-HafasSort",
                      attrs: { type: "hidden", name: "search", value: "1" },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "g-recaptcha",
                      attrs: {
                        id: "recaptcha",
                        "data-tabindex": "99",
                        "data-sitekey":
                          "6LfNgbIZAAAAAJRnN7xCoQZH-gq-fiMYFAoNxOcR",
                        "data-callback": "onSubmitSearchForm",
                        "data-action": "submit",
                        "data-size": "invisible",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-warning w-100",
                        attrs: {
                          type: "submit",
                          name: "search",
                          value: "1",
                          onClick: "return grecaptcha.execute();",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("icsearch_wyszukaj")))]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", [_vm._t("dev")], 2),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "alerts mt-3" },
      [
        _vm._t("alerts-slot", function () {
          return [_vm._m(0)]
        }),
        _vm._v(" "),
        _vm._t("info"),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "alert alert-warning font-size-sm d-flex",
        attrs: { role: "alert" },
      },
      [
        _c("div", { staticClass: "me-4 text-danger" }, [
          _c("i", { staticClass: "bi bi-exclamation-circle" }),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n          W pociągach PKP Intercity jednocześnie zajętych może być co najwyżej 50 proc. miejsc siedzących."
          ),
          _c("br"),
          _vm._v(" "),
          _c("a", { attrs: { href: "#" } }, [
            _vm._v("Więcej informacji na temat obowiązujących zasad w podróży"),
          ]),
          _vm._v(" "),
          _c("br"),
          _c("br"),
          _vm._v(
            "\n          W pociągach PKP Intercity jednocześnie zajętych może być co najwyżej 50 proc. miejsc siedzących."
          ),
          _c("br"),
          _vm._v(" "),
          _c("a", { attrs: { href: "#" } }, [
            _vm._v("Więcej informacji na temat obowiązujących zasad w podróży"),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }